module.exports = __webpack_public_path__ + "static/media/tree-step-6_5.10ea3ae0.svg";